export const BRAZE_EVENTS = {
  on_site_check_in: 'on_site_check_in',
  page_view: 'page_view_',
  // Anonymous user events
  anonymous_session_start: 'anonymous_session_start',
  anonymous_to_identified: 'anonymous_to_identified',
}

//Analytics dash: https://www.notion.so/premierlacrosseleague/Analytics-Tags-Database-ca224c3268ec4c7c914c408b3e68b396?pvs=4
export const ANALYTICS_TAGS = {
  // Login //
  log_in: 'logged_in',
  log_out: 'logged_out',
  phone_login_click: 'phone_login_click',
  email_login_click: 'email_login_click',
  google_login_click: 'google_login_click',
  google_config_missing: 'google_config_missing',
  login_cancelled: 'login_cancelled',
  login_error: 'login_error',

  // Auth Errors //
  auth_initialization_error: 'auth_initialization_error',
  auth_state_change_error: 'auth_state_change_error',
  auth_change_error: 'auth_change_error',
  user_fetch_failed: 'user_fetch_failed',
  user_change_error: 'user_change_error',
  first_time_user_check_error: 'first_time_user_check_error',
  user_db_fetch_error: 'user_db_fetch_error',
  braze_init_error: 'braze_init_error',
  user_state_set_error: 'user_state_set_error',
  firebase_user_retry_createUser: 'firebase_user_retry_createUser',
  firebase_user_retry_createUser_failed: 'firebase_user_retry_createUser_failed',
  // When firebase has indexedDB issue
  firebase_transaction_error: 'firebase_transaction_error',

  // Braze Errors //
  braze_provider_initialization_failed: 'braze_provider_initialization_failed',
  braze_show_pending_message_failed: 'braze_show_pending_message_failed',
  braze_subscription_cleanup_failed: 'braze_subscription_cleanup_failed',
  braze_alias_missing_user_or_method: 'braze_alias_missing_user_or_method',
  braze_addAlias_call_failed: 'braze_addAlias_call_failed',
  braze_alias_exception: 'braze_alias_exception',
  braze_setupBrazeSession: 'braze_setupBrazeSession',

  // reCAPTCHA //
  recaptcha_expired: 'recaptcha_expired',
  recaptcha_error: 'recaptcha_error',
  recaptcha_init_failed: 'recaptcha_init_failed',

  // User //
  fav_team_click: 'fav_team_click',
  join_pll_nation_click: 'join_pll_nation_click',

  // SEASON //
  season_selection_change: 'season_selection_change',
  week_selection_change: 'week_selection_change',
  standings_toggle_click: 'standings_toggle_click',
  boxscore_click: 'boxscore_click',
  schedule_btn_click: 'schedule_btn_click',
  schedule_week_click: 'schedule_week_click',
  ticket_click: 'ticket_click',
  recap_click: 'recap_click', // Clicking boxscore recap button
  standings_team_click: 'standings_team_click',

  bracket_action_click: 'bracket_action_click',

  // TEAM & PLAYER //
  player_roster_click: 'player_roster_click',
  leader_click: 'leader_click',
  roster_bio_click: 'roster_bio_click',

  // CONTENT //
  article_click: 'article_click',
  video_start: 'video_start',
  video_watched: 'video_watched',
  video_category_click: 'video_category_click',
  video_click: 'video_click',

  // STORAGE //
  storage_operation: 'storage_operation',
  storage_failure: 'storage_failure',
  storage_retrieval_failure: 'storage_retrieval_failure',

  // NETWORK //
  network_error: 'network_error',
  max_failed_fetch_reached: 'max_failed_fetch_reached',

  //OTHER //
  home_banner_click: 'home_banner_click',
  banner_click: 'banner_click',
  banner_impression: 'banner_impression',
  watch_click: 'watch_click',
  app_callout_click: 'app_callout_click',
  callout_card_click: 'callout_card_click',
  twitter_click: 'twitter_click',
  instagram_click: 'instagram_click',
  youtube_click: 'youtube_click',
  tiktok_click: 'tiktok_click',
  discord_click: 'discord_click',

  // PLAYER STATS //
  player_stats_chart_toggle_stat: 'player_stats_chart_toggle_stat',

  // ALLSTAR //
  allstar_vote_status_check: 'allstar_vote_status_check',
  allstar_vote_status_error: 'allstar_vote_status_error',
  allstar_vote_button_locked: 'allstar_vote_button_locked',
  allstar_player_select: 'allstar_player_select',
  allstar_player_remove: 'allstar_player_remove',
  allstar_team_switch: 'allstar_team_switch',
  allstar_position_filter: 'allstar_position_filter',
  allstar_vote_attempt: 'allstar_vote_attempt',
  allstar_vote_success: 'allstar_vote_success',
  allstar_vote_failure: 'allstar_vote_failure',
  allstar_team_tab_change: 'allstar_team_tab_change',
  allstar_wll_team_tab_change: 'allstar_wll_team_tab_change',

  // EVENT HUB //
  gameday_hub_tab_change: 'gameday_hub_tab_change',
  gameday_hub_experience_link_click: 'gameday_hub_experience_link_click',
  gameday_hub_experience_more_click: 'gameday_hub_experience_more_click',

  // FEED //
  feed_category_click: 'feed_category_click',
  feed_item_click: 'feed_item_click',
  article_author_click: 'article_author_click',
}
